import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { IPublishedConnectionTable } from '../types/IPublishedConnectionTable';

export interface IGetPublishedConnectionTablesParams extends IGetItemsParams {
}

export interface IGetPublishedConnectionTablesResult extends IGetItemsResult {
  publishedConnectionTables?: IPublishedConnectionTable[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetPublishedConnectionTablesRequest extends Request<IGetPublishedConnectionTablesParams, IGetPublishedConnectionTablesResult> {
  constructor(params: IGetPublishedConnectionTablesParams) {
    super('getPublishedConnectionTables', params);
  }
}
